var map = {
  "./choice-4x4-grijs-kenteken.svg": "2721",
  "./choice-bakwagen.svg": "5117",
  "./choice-bedrijfsfiets-2000l.svg": "3246",
  "./choice-bedrijfsfiets-3000l.svg": "6783",
  "./choice-cargobike-2000l.svg": "8061",
  "./choice-cargobike-3000l.svg": "9468",
  "./choice-cargobike-koel-vries.svg": "9702",
  "./choice-dubbele-cabine.svg": "5537",
  "./choice-enkele-cabine.svg": "1566",
  "./choice-grote-koelwagen.svg": "878",
  "./choice-kleine-bestelwagen.svg": "3247",
  "./choice-kleine-koelwagen.svg": "3435",
  "./choice-koel-bakwagen.svg": "6421",
  "./choice-middel-koel-vrieswagen.svg": "6332",
  "./choice-open-laadbak.svg": "3990",
  "./choice-overbrengvoertuig.svg": "9776",
  "./choice-overig.svg": "7863",
  "./choice-personenvervoer.svg": "7558",
  "./choice-pick-up.svg": "5124",
  "./choice-rolstoelvervoer.svg": "7794",
  "./choice-rouwvoertuig.svg": "1057"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5483;
